import ENV from "app/utils/ENV";
import apiActions from "app/utils/apiActions";
import storageActions from "app/utils/storageActions";
import valueHelpers from "app/utils/valueHelpers";
import valueActions from "app/utils/valueActions";
import textHelpers from "app/utils/textHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { Platform, Alert } from "react-native";

import store from "app/redux/store";

let prefActions = {
  async get(appLaunch = false) {
    let pref = await apiActions.request(
      `preferences/0?app_launch=${appLaunch}`,
    );
    if (!!pref) {
      this.setPrefs(pref);
      return pref;
    }
  },
  async update(preference) {
    let pref = await apiActions.request("preferences/0", "PATCH", {
      preference,
    });
    if (!!pref) {
      this.setPrefs(pref);
      return pref;
    }
  },
  setPrefs(pref) {
    let preferences = {
      todoIds: pref.todo_ids,
      hiddenIds: pref.hidden_ids,
      focusIds: pref.focus_ids,
      dismissedTodos: pref.dismissed_todos,
      schemeMode: pref.scheme_mode,
      lightTheme: pref.light_theme,
      darkTheme: pref.dark_theme,
      detailsMode: pref.details_mode,
      range: pref.range,
      // ...pref,
    };
    store.dispatch({ type: "preferences/update", preferences });
    storageActions.saveItem("preferences", preferences);
  },
  // async updateToDoIds(ids=[]){
  //   let todoIds = null
  //   let pref = await apiActions.request('preferences/0', 'PATCH', {todo_ids: ids})
  //   if(pref) todoIds = pref.todo_ids
  //   // await storageActions.saveItem('todoIds', todoIds)
  //   return todoIds
  // },
  // async updateFocusIds(ids=[]){
  //   let focusIds = null
  //   let local = await storageActions.fetchItem('local', ENV.LOCAL)
  //   if(!local){
  //     let pref = await apiActions.request('preferences/0/update_focus_ids', 'PATCH', {focus_ids: ids})
  //     if(pref) focusIds = pref.focus_ids
  //   }
  //   if(!focusIds){
  //     focusIds = ids
  //   }
  //   await storageActions.saveItem('focusIds', focusIds)
  //   return focusIds
  // },
  async addToDo(id) {
    let preferences = store.getState().preferences;
    let { todoIds, dismissedTodos } = preferences;
    let data = {};
    if (!todoIds.includes(id)) {
      todoIds = [id, ...todoIds];
      data.todo_ids = todoIds;
    }
    if (!!dismissedTodos.find((x) => x.startsWith(`${id}:`))) {
      dismissedTodos = dismissedTodos.filter((x) => !x.startsWith(`${id}:`));
      data.dismissed_todos = dismissedTodos;
    }
    if (JSON.stringify(data) != "{}") {
      let pref = await apiActions.request("preferences/0", "PATCH", {
        preference: data,
      });
      if (!!pref) {
        todoIds = pref.todo_ids;
        store.dispatch({ type: "preference/update", todoIds });
        dismissedTodos = pref.dismissed_todos;
        store.dispatch({ type: "preference/update", dismissedTodos });
      }
    }
  },
  async removeToDo(id, prompt = false) {
    let preferences = store.getState().preferences;
    let { todoIds, dismissedTodos } = preferences;
    let remove = todoIds.includes(id);
    if (prompt) {
      let actionName = remove ? "Remove" : "Dismiss";
      let message = remove
        ? "Remove item from todo list?"
        : "Dismiss item for today?";
      let confirm = await valueActions.confirm(actionName, "", message);
      if (!confirm) return;
    }
    if (remove) {
      todoIds = todoIds.filter((i) => i != id);
      let pref = await apiActions.request("preferences/0", "PATCH", {
        preference: { todo_ids: todoIds },
      });
      if (!!pref) {
        todoIds = pref.todo_ids;
        store.dispatch({ type: "preference/update", todoIds });
      }
    } else {
      if (!prompt) return; // this means we were coming from an auto-remove (progression)
      // assume it is due, so dismiss it
      console.log("dismissing!");
      // remove any previous dismissals
      dismissedTodos = dismissedTodos.filter((x) => !x.startsWith(`${id}:`));
      dismissedTodos = [...dismissedTodos, `${id}:${new Date().toISOString()}`];
      let pref = await apiActions.request("preferences/0", "PATCH", {
        preference: { dismissed_todos: dismissedTodos },
      });
      if (!!pref) {
        console.log(pref.dismissed_todos);
        dismissedTodos = pref.dismissed_todos;
        store.dispatch({ type: "preference/update", dismissedTodos });
      }
    }
  },
  async undismiss(id) {
    let preferences = store.getState().preferences;
    let { dismissedTodos } = preferences;
    dismissedTodos = dismissedTodos.filter((x) => !x.startsWith(`${id}:`));
    let pref = await apiActions.request("preferences/0", "PATCH", {
      preference: { dismissed_todos: dismissedTodos },
    });
    if (!!pref) {
      console.log(pref.dismissed_todos);
      dismissedTodos = pref.dismissed_todos;
      store.dispatch({ type: "preference/update", dismissedTodos });
    }
  },
  async hideValue(id) {
    let hiddenIds = store.getState().preferences.hiddenIds;
    if (!hiddenIds.includes(id)) {
      let confirm = await valueActions.confirm("hide value");
      if (!confirm) return;
      hiddenIds = [...hiddenIds, id];
      let pref = await apiActions.request("preferences/0", "PATCH", {
        preference: { hidden_ids: hiddenIds },
      });
      if (!!pref) {
        hiddenIds = pref.hidden_ids;
        store.dispatch({ type: "preference/update", hiddenIds });
      }
    }
  },
  async unhideValue(id) {
    let hiddenIds = store.getState().preferences.hiddenIds;
    if (hiddenIds.includes(id)) {
      hiddenIds = hiddenIds.filter((i) => i != id);
      let pref = await apiActions.request("preferences/0", "PATCH", {
        preference: { hidden_ids: hiddenIds },
      });
      if (!!pref) {
        hiddenIds = pref.hidden_ids;
        store.dispatch({ type: "preference/update", hiddenIds });
      }
    } else alert("nope");
  },
  async addFocus(id) {
    let focusIds = store.getState().preferences.focusIds;
    if (!focusIds.includes(id)) {
      focusIds = [...focusIds, id];
      let pref = await apiActions.request("preferences/0", "PATCH", {
        preference: { focus_ids: focusIds },
      });
      if (!!pref) {
        focusIds = pref.focus_ids;
        store.dispatch({ type: "preference/update", focusIds });
      }
    }
  },
  async removeFocus(id) {
    let focusIds = store.getState().preferences.focusIds;
    if (focusIds.includes(id)) {
      focusIds = focusIds.filter((i) => i != id);
      let pref = await apiActions.request("preferences/0", "PATCH", {
        preference: { focus_ids: focusIds },
      });
      if (!!pref) {
        focusIds = pref.focus_ids;
        store.dispatch({ type: "preference/update", focusIds });
      }
    }
  },
  // cycleOptions: ["titles", "all", "categories", "tasks"], //, "badges"],
  cycleOptions: ["titles", "all"], //, "badges"],
  async setDetailsMode(details_mode) {
    let res = await prefActions.update({ details_mode });
  },
  async cycleDetailsMode() {
    let options = prefActions.cycleOptions;
    let mode =
      store.getState().preferences.detailsMode || options[options.length - 1];
    let newMode = options[options.indexOf(mode) + 1];
    if (!newMode) newMode = options[0];
    let pref = { details_mode: newMode };
    let res = await prefActions.update(pref);
  },
};

export default prefActions;
